<template>
  <main class="sa-content">
    <ValidationObserver
      ref="form"
      tag="div"
      v-slot="{ handleSubmit }"
      @keyup.enter="handleSubmit(saveData)"
    >
      <div v-if="!loading && pFlag" class="sa-card-large">
        <div class="sa-mob-header">
          <h5 class="sa-card-tit">{{ menu.title }}</h5>
          <button class="sa-btn-back">
            <i class="icon-arrow-left" @click="backAction"></i>
          </button>
        </div>

        <div class="sa-mob-cont sa-mob-cont-padbt">
          <div class="sa-row">
            <ValidationProvider
              class="sa-col-xs12 sa-col-sm6 sa-col-md5 sa-col-lg4"
              tag="div"
              rules="required"
              :name="menu.name"
              v-slot="{ errors }"
            >
              <div class="sa-form-group">
                <label
                  >Add {{ menu.name
                  }}<span class="sa-red-text">*</span></label
                >
                <v-select
                   :options="serviceOptions"
                  v-model="presData.srv_nme"
                  label="name"
                  :reduce="option => option.name"
                  id="srv_nme"
                  name="srv_nme"
                  class="sa-v-slct-lg"
                  @input="onServiceSelect"
                >
                  <template #no-options>No data</template>
                </v-select>
                <span class="sa-val-err">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>

            <div class="sa-col-lg12">
              <div class="sa-form-group suffix">
                <label>Add Instruction</label>
                <textarea
                  v-model="presData.inst"
                  type="text"
                  class="sa-form-control sa-textarea-lg"
                  id="inst"
                  name="inst"
                ></textarea>
              </div>
            </div>

            <ValidationProvider
              class="sa-col-xs12 sa-col-sm6 sa-col-md5 sa-col-lg4"
              tag="div"
              :rules="{ required: true, minQuantity: true, maxQuantity: true }"
              name="Quantity"
              v-slot="{ errors }"
            >
              <div class="sa-form-group">
                <label
                  >Quantity<span class="sa-red-text">*</span></label
                >
                <input
                  type="number"
                  class="sa-form-control sa-form-control-lg"
                  id="Quantity"
                  name="Quantity"
                  v-model="presData.quantity"
                  @keypress="preventDecimalPoint"
                />
                <span class="sa-val-err">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>



            <ValidationProvider
              class="sa-col-xs6 sa-col-sm6 sa-col-md3 sa-col-lg3"
              tag="div"
              name="Dose"
              v-slot="{ errors }"
            >
              <div class="sa-form-group">
                <label>Dose<span class="sa-red-text"></span></label>
                <input
                  type="text"
                  class="sa-form-control sa-form-control-lg"
                  id="dose"
                  name="Dose"
                  v-model="presData.dose"
                />
                <span class="sa-val-err">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            <ValidationProvider
              class="sa-col-xs6 sa-col-sm6 sa-col-md3 sa-col-lg3"
              tag="div"
              name="Dose Unit"
              v-slot="{ errors }"
            >
              <div class="sa-form-group sa-ellipsis-full">
                <label>Dose Unit<span class="sa-red-text"></span></label>
                <!-- <input
                  type="text"
                  class="sa-form-control sa-form-control-lg"
                  id="dose"
                  name="Dose"
                  :disabled="!dflag"
                  v-model="drugObj.dose_unit"
                /> -->
                <v-select :options="doseUnits" v-model="presData.dose_unit" id="doseUnit" name="Dose Unit" class=" sa-v-slct-lg"><span slot="no-options">No data</span></v-select>
                <span class="sa-val-err">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          

            <ValidationProvider
              class="sa-col-xs6 sa-col-sm6 sa-col-md5 sa-col-lg2"
              tag="div"
              name="Duration"
              v-slot="{ errors }"
            >
              <div class="sa-form-group">
                <label>Duration<span class="sa-red-text"></span></label>
                <input
                  type="text"
                  class="sa-form-control sa-form-control-lg"
                  id="duration"
                  v-model="presData.dur"
                  name="Duration"
                />
                <span class="sa-val-err">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            <ValidationProvider
              class="sa-col-xs6 sa-col-sm6 sa-col-md5 sa-col-lg2"
              tag="div"
              name="Duration Unit"
              v-slot="{ errors }"
            >
              <div class="sa-form-group">
                <label>Duration Unit<span class="sa-red-text"></span></label>
                <v-select
                  :options="duration"
                  v-model="presData.dur_unit"
                  id="durationUnit"
                  name="Duration Unit"
                  class="sa-v-slct-lg"
                  ><span slot="no-options">No data</span></v-select
                >
                <span class="sa-val-err">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>



            <ValidationProvider
              class="sa-col-xs12 sa-col-sm6 sa-col-md5 sa-col-lg4"
              tag="div"
              rules="required"
              name="Indications"
              v-slot="{ errors }"
            >
              <div class="sa-form-group">
                <label
                  >Indications<span class="sa-red-text">*</span></label
                >
                <v-select
                  :options="assesment"
                  v-model="presData.indications"
                  id="indications"
                  name="Indications"
                  class="sa-v-slct-lg"
                >
                  <template #no-options>No data</template>
                </v-select>
                <span class="sa-val-err">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          </div>
        </div>

        <div class="sa-ftr-btn">
          <button class="sa-btn sa-btn-large sa-btn-default" @click="backAction">
            Discard
          </button>

          <button
            v-if="presData && presData.item_id"
            class="sa-btn sa-btn-large sa-btn-primary sa-ml20"
            :disabled="loader"
            @click="handleSubmit(updateData)"
          >
            Update 
          </button>

          <button
            v-else
            class="sa-btn sa-btn-large sa-btn-primary sa-ml20"
            :disabled="loader"
            @click="handleSubmit(saveData)"
          >
            Save 
          </button>
        </div>
      </div>

      <div v-else class="sa-text-center">
        <img src="../../../../assets/img/loader.svg" alt="loader" />
      </div>
    </ValidationObserver>
  </main>
</template>

<script>

import { oh_url, pro_url } from "../../../../../config/endpoints.js";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import _ from "lodash";

extend("required", {
  ...required,
  message: "Please provide {_field_}",
});

extend("maxQuantity", {
  validate(value) {
    return parseInt(value) <= 12;
  },
  message: "The {_field_} must be 12 or less",
});

extend("minQuantity", {
  validate(value) {
    return parseInt(value) >= 1;
  },
  message: "The {_field_} must be 1 or more",
});

export default {
  computed: {
  serviceOptions() {
    return Object.entries(this.getList).map(([key, value]) => ({
      id: key,
      name: value,
    }));
  },
},
  props: ["Item", "drugList", "prescribedItem", "listData"],
  data() {
    return {
      loading: true,
      FlagType: false,
      pFlag: false,
      getList: [],
      name: "",
      menu: {
        title: null,
      },
      type: "",
      assesment: [],
      doseUnits:[],
      duration:[],
      presData: {
        item_id: null,
        apnt_id: null,
        srv_nme: null,
        inst: null,
        indications: null,
        quantity: null,
        dose:null,
        doseUnit:null,
        dur:null,
        dur_unit:null,
        srv_id: null
      },
      patDetails: {},
    };
  },

  methods: {
    preventDecimalPoint(event) {
      const keyCode = event.keyCode || event.which;
      const controlKeys = [8, 9, 13, 27, 37, 38, 39, 40];
      if (controlKeys.includes(keyCode)) return;
      const char = String.fromCharCode(keyCode);
      if (!/[0-9]/.test(char)) {
        event.preventDefault();
      }
    },

    backAction() {
      this.presData = {};
      if (this.listData?.prescflags?.presc_exists) {
        this.viewMedFlag = true;
        this.drgid = null;
        this.presData = {};
        this.$emit("close-pop");
      } else {
        if (typeof window != undefined && window.ReactNativeWebView) {
          let data = { action: "end" };
          window.ReactNativeWebView.postMessage(JSON.stringify(data));
        }
        this.presData = {};
        this.$router.push(
          "/appointments/doctor-details/add-diagnosis/" +
            this.$route.params.appid
        );
      }
    },

    fetchPatDetails() {
      let _self = this;
      if (_self.$route.query.token) {
        if(_self.$route.query.refreshToken){
          _self.$localStorage.set('refresh_token', _self.$route.query.refreshToken)
        }
        _self.$store
          .dispatch("httpGet", {
            uri: `${pro_url}/apt/${_self.$route.params.appid}`,
            query: {},
          })
          .then((response) => {
            if (response && response.status === 1000) {
              _self.details = response.data;
              _self.patDetails = {
                apnt_id: _self.details.apnt_id,
                pid: _self.details.pid,
                sanar_uid: _self.details.sanar_uid,
              };
              _self.$localStorage.set(
                "patDetails",
                JSON.stringify(_self.patDetails)
              );
              this.loading = false;
            } else {
              this.loading = false;
            }
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
          });
      } else {
        this.loading = false;
      }
    },

    getPrescriptionData() {
      let _self = this;
      _self.$store
        .dispatch("httpPost", {
          uri: `${oh_url}/pro/prescribedItems`,
          body: {
            type:
              _self.Item && _self.Item.type
                ? _self.Item.type
                : Number(_self.$route.query.type),
          },
        })
        .then((response) => {
          if (response && response.status == 1000) {
            _self.getList = response.data;
            _self.pFlag = true;
          }
        })
        .catch((e) => console.log(e));
    },

    saveData() {
      let _self = this;
      let req = _self.presData;
      _self.loading = true
      req.type =
        _self.Item && _self.Item.type
          ? _self.Item.type
          : Number(_self.$route.query.type);

      _self.$store
        .dispatch("httpPost", {
          uri: `${oh_url}/pro/savePrescribedItems`,
          body: req,
        })
        .then((response) => {
          if (response.status == 1000) {
         
            if (_self.$route.query.type) {
              _self.$router.push(
                "/appointments/doctor-details/add-diagnosis/add-prescription/" +
                  _self.$route.params.appid
              );
            } else {
              _self.$emit("close-pop");
            }
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: "Added " + _self.menu.name + " successfully",
              class: "sa-a-success",
            });
            _self.presData = {};
            _self.loading = false
          }else{
            _self.loading = false;
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              // msg: response && response.message ?response.message : "Something went wrong. Please try again or contact operations team",
              msg: _self.menu.name + " already added",
              class: "sa-a-danger",
            });
          }
        })
        .catch((e) => console.log(e));
    },

    updateData() {
      let _self = this;
      let req = _self.presData;
      // delete req.apnt_id;
      req.type =
        _self.Item && _self.Item.type
          ? _self.Item.type
          : Number(_self.$route.query.type);

      _self.$store
        .dispatch("httpPost", {
          uri: `${oh_url}/pro/editPrescribedItems`,
          body: req,
        })
        .then((response) => {
          if (response.status == 1000) {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: "Updated " + _self.menu.name + " successfully",
              class: "sa-a-success",
            });
            _self.presData = {};
            this.$emit("close-pop");
          }
        })
        .catch((e) => console.log(e));
    },

    getAssementData() {
      let _self = this;
      let data = { apnt_id: this.$route.params.appid };

      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/prescription/assessment`,
          body: data,
        })
        .then((response) => {
          if (response) {
            _self.assesment = _.values(response.data.Assesment);
            if (!_self.assesment.length) {
              _self.$store.dispatch("SET_ALERTMESSAGE", {
                msg: "Please select one assesment",
                class: "sa-a-danger",
              });
            }
          }
        })
        .catch((e) => console.log(e));
    },

    getStaticData() {
      let _self = this;
      _self.$store
        .dispatch("httpGet", {
          uri: `${pro_url}/getPrescriptionMasterData`,
        })
        .then((response) => {
          if (response) {
            _self.doseUnits = _.values(response.data.doseunits);
           _self.duration = _.values(response.data.durations);
          
          }
        })
        .catch((e) => console.log(e));
    },
    onServiceSelect(selectedName) {
    const selectedOption = this.serviceOptions.find(
      opt => opt.name === selectedName
    );
    if (selectedOption) {
      this.presData.srv_id = selectedOption.id;
    } else {
      this.presData.srv_id = null;
    }
  },
   
  
    
  },

  mounted() {
    let _self = this;
    _self.day_cnt = null;
    this.loading = true;
    _self.presData = _self.prescribedItem || {};

    if (_self.presData && _self.presData.item_id) {
      this.FlagType = true;
    }

    _self.getPrescriptionData();
    _self.getAssementData();
    _self.getStaticData()

    if (_self.$route.query.type) {
      if (Number(_self.$route.query.type) == 1) {
        _self.menu = {
          title: this.FlagType ? "Edit Milk" : "Add Milk",
          name: "Milk",
        };
      } else if (Number(_self.$route.query.type) == 2) {
        _self.menu = {
          title: this.FlagType ? "Edit Supplies and Devices" : "Add Supplies and Devices",
          name: "Supplies and Devices",
        };
      } else if (Number(_self.$route.query.type) == 3) {
        _self.menu = {
          title: this.FlagType ? "Edit Medical Device" : "Add Medical Device",
          name: "Medical Device",
        };
      }
    } else {
      if (_self.Item.type == 1) {
        _self.menu = {
          title: this.FlagType ? "Edit Milk" : "Add Milk",
          name: "Milk",
        };
      } else if (_self.Item.type == 2) {
        _self.menu = {
          title: this.FlagType ? "Edit Supplies and Devices" : "Add Supplies and Devices",
          name: "Supplies and Devices",
        };
      } else if (_self.Item.type == 3) {
        _self.menu = {
          title: this.FlagType ? "Edit Medical Device" : "Add Medical Device",
          name: "Medical Device",
        };
      }
    }

    var field = document.createElement("input");
    field.setAttribute("type", "text");
    document.body.appendChild(field);
    setTimeout(function () {
      field.focus();
      setTimeout(function () {
        field.setAttribute("style", "display:none;");
      }, 50);
    }, 50);

    if (typeof window != "undefined") {
      window.addEventListener("message", function (message) {
        if (message && message.data) {
          let res = JSON.parse(message.data);
          if (res && res.action == "back") {
            if (res.page == "prescription list") {
              if (window.ReactNativeWebView) {
                let data = { action: "end" };
                window.ReactNativeWebView.postMessage(JSON.stringify(data));
              }
            } else if (res.page == "add medicine") {
              _self.backAction();
            } else if (res.page == "issue prescription") {
              if (!_self.$refs["addMedicine"].saveDrugFlag) {
                _self.$refs["addMedicine"].saveDrugFlag = true;
                _self.$refs["addMedicine"].saveDrugViewFlag = true;
              } else {
                _self.$refs["addMedicine"].saveDrugFlag = false;
                _self.$refs["addMedicine"].saveDrugViewFlag = false;
              }
              
            } else if (res.page == "complete") {
              if (window.ReactNativeWebView) {
                let data = { action: "complete" };
                window.ReactNativeWebView.postMessage(JSON.stringify(data));
              }
            }
            this.loading = false;
          }
        }
      });
    }

    this.patDetails = JSON.parse(this.$localStorage.get("patDetails"));
    if (this.patDetails) {
      this.apnt_id = this.patDetails.apnt_id;
      if(this.$route &&this.$route.params && this.$route.params.appid ){
          this.presData.apnt_id =  this.$route.params.appid 
      }
      else if (this.presData) {
        this.presData.apnt_id = this.patDetails.apnt_id;
      } 
    }

    this.fetchPatDetails();
  },
};
</script>
